module.exports = __webpack_public_path__ + "static/Hero-bb1bef95d75ad8ecca18780690dcac27.png";